
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"44","viewBox":"0 0 21 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.38 17.747c-.163 0-.326-.04-.489-.122l-6.186-3.582c-.285-.162-.448-.488-.448-.854V6.066c0-.367.163-.652.488-.855l6.187-3.582c.285-.163.651-.163.977 0l6.187 3.582a.992.992 0 01.488.855v7.163c0 .367-.203.652-.488.855l-6.228 3.541c-.122.082-.285.122-.488.122zM5.17 12.66l5.21 3.012 5.21-3.011V6.634l-5.21-3.012-5.21 3.012v6.024z","fill":"#F4EC4E"}}),_c('path',{attrs:{"d":"M10.38 44c-.204 0-.367-.041-.53-.123L.53 38.464a1.077 1.077 0 01-.53-.936V26.782c0-.366.204-.733.53-.936l4.192-2.442c.529-.285 1.18-.122 1.465.407.285.488.122 1.18-.407 1.465l-3.663 2.117v9.524l8.262 4.762 8.263-4.762v-9.524L6.024 20.107a1.077 1.077 0 01-.53-.936v-3.827c0-.61.49-1.058 1.06-1.058.61 0 1.058.489 1.058 1.058v3.175l12.618 7.286c.325.204.529.53.529.936v10.746c0 .407-.204.733-.53.936l-9.32 5.373c-.123.163-.326.203-.53.203zM4.07 3.582l2.727-1.588L4.07 0v3.582zM17.054 3.582l-2.727-1.588L17.054 0v3.582z","fill":"#F4EC4E"}})])
          )
        }
      }
    